import { getPathDatabaseByRole } from "../actions/auth";
import { useDispatchApp, useSelectorApp } from "../lib/redux";

/**
 * True when `agenciesFeatureFlags/mcp` includes the current agency.
 * Enables the MCP tab in Settings.
 */
const useAgencyHasMcpFeature = () => {
  const dispatch = useDispatchApp();
  const { agencyID } = dispatch(getPathDatabaseByRole());
  const agencies = useSelectorApp(
    (state) => state.ui.agenciesFeatureFlags?.mcp ?? []
  );

  return Boolean(agencyID) && agencies.includes(agencyID);
};

export default useAgencyHasMcpFeature;
